export const globalChannel = new BroadcastChannel("neoconecta-global-channel");